module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-32.d56eb57b.png";